import { useMutation, useQuery } from 'react-query';
import apiClient from '../apiClient/apiClient';
import { CategoryKey } from './image.types';

export const useSusGuiImages = (requestBody: { category?: CategoryKey, fileName?: string }, enabled: boolean = false) => {
  return useQuery<Blob>({
    queryKey: ['sus-gui-images', requestBody.category, requestBody.fileName],
    queryFn: async () => {
      const { data } = await apiClient.get<string>(`/images/susgui/${requestBody.category}/${requestBody.fileName}`, { responseType: 'blob', headers: { 'Content-Type': 'application/octet-stream' } });
      return new Blob([data], { type: 'image/jpeg' });
    },
    enabled: enabled,
  });
};

export const useSusGuiImagesUploadFile = (attributeType: CategoryKey, fileName: string) => {
  return useMutation((record: FormData) =>
      apiClient.put(`/images/susgui/${attributeType}/${fileName}`, record, {headers: { 'Content-Type': 'multipart/form-data' }})
  );
};

export const useSusGuiImagesDeleteFile = (attributeType: CategoryKey, fileName: string) => {
  return useMutation(() =>
      apiClient.delete(`/images/susgui/${attributeType}/${fileName}`)
  );
};

export const useSusGuiImageExtract = () => {
 return useMutation((params) => {
    return apiClient.post(`/extracts/sus-gui`);
 })
};
